import {
  BooleanField,
  Datagrid,
  FunctionField,
  List,
  Pagination,
  TextField,
  TextInput,
} from 'react-admin';
import { useRecordContext } from 'ra-core';
import { Link } from 'react-router-dom';
import React from 'react';
import { DateTime } from 'luxon';
import { isDateOverdue } from '../../utils/is-date-overdue';
import { IS_REVOKED_RP } from '../../utils/shared';

const UserLink = (props: any) => {
  const { source } = props;
  const record = useRecordContext(props);
  const value = record[source];

  const userShowPage = `/user/${value}/show`;
  return <Link to={userShowPage}>{value}</Link>;
};

const PostPagination = () => (
  <Pagination rowsPerPageOptions={[10, 25, 50, 100]} />
);

const filters = [
  <TextInput source="id" alwaysOn name="userId" label="User ID" />,
];

export const UserList = () => {
  return (
    <List
      resource="user"
      pagination={<PostPagination />}
      hasCreate={false}
      exporter={false}
      filters={filters}
    >
      <Datagrid>
        <UserLink source="id" name="User" />
        <TextField source="rewardPoints" />
        <FunctionField
          label="CSB Enabled"
          render={({ csbEnabled }: any) => (
            <BooleanField
              record={{ csbEnabled: Boolean(csbEnabled) }}
              source="csbEnabled"
            />
          )}
        />
        <FunctionField
          label="GCD Enabled"
          render={({ gcdEnabled }: any) => (
            <BooleanField
              record={{ gcdEnabled: Boolean(gcdEnabled) }}
              source="gcdEnabled"
            />
          )}
        />
        <FunctionField
          label="Can Redeem"
          render={({ canRedeem }: any) => (
            <BooleanField
              record={{ canRedeem: Boolean(canRedeem) }}
              source="canRedeem"
            />
          )}
        />
        <FunctionField
          label="Spent daily £"
          render={({ lastSpent, spentGbpDaily }: any) => {
            const needToResetDailySpend = isDateOverdue(lastSpent, 'day');

            return needToResetDailySpend ? 0 : spentGbpDaily;
          }}
        />
        <FunctionField
          label="Spent monthly £"
          render={({ lastSpent, spentGbpMonthly }: any) => {
            const needToResetDailySpend = isDateOverdue(lastSpent, 'day');

            return needToResetDailySpend ? 0 : spentGbpMonthly;
          }}
        />
        <FunctionField
          label="Last Spent At"
          render={({ lastSpent }: any) =>
            (lastSpent ?? 0) !== 0
              ? DateTime.fromMillis(lastSpent ?? 0).toFormat('dd/MM/yyyy HH:mm')
              : 'never'
          }
        />
        <FunctionField
          label="User subscription is cancelled"
          render={({ isCancelled }: any) => (
            <BooleanField
              record={{ isCancelled: Boolean(isCancelled) }}
              source="isCancelled"
            />
          )}
        />
        <FunctionField
          label="Revoked RP"
          render={({ isCancelled }: any) => (
            <BooleanField
              record={{ isCancelled: isCancelled === IS_REVOKED_RP }}
              source="isCancelled"
            />
          )}
        />
      </Datagrid>
    </List>
  );
};
